export const contactsData = [
    {
        prospect: "Trisha Smith",
        interestedIn: "1221 Mcdonald Dr., 4917 S. Briarwood Dr., 3021 NW 13th Street, 217 NW 121st St., 2324 NW 109th, 721 NW 114th St., 9613 Ridgeview, 425 NW 120th Street, 9723 NE 3rd Pl, 1401 Hampton Dr., 1213 NW 105th Terrace, 3513 Simmons Dr, 732 NE 81st Street, 600 NW 116th Terr., 261 NW 79th Street, 1311 NW 81st St, 248 NW 85th Street, 2633 SW 45th St., 4005 Locust Dr., 12614 Abbotts Way, 4712 Judy Drive, 4024 N Libby Ave, 4904 Gaines St., 5813 SE 10th St., 10917 N. McKinley Avenue, 10721 N. McKinley Ave.",
        Source: "Zillow Rental Network",
        activity: "6:15AM 01/20/2023"
    },
    {
        prospect: "Kim Taylor",
        interestedIn: "3918 SE 14th Street, 1941 Treat Drive, 4813 Republic Dr., 3724 SE 48th Pl, 1913 NE 44th St., 9723 NE 3rd Pl",
        Source: "Zumper",
        activity: "7:14PM 01/06/2023"
    },
    {
        prospect: "Amber Hickerson",
        interestedIn: "4515 SE 28th St., 1712 Hanna Dr., 2508 Trigg Dr., 1633 Hampton Dr. Del City, 3724 SE 48th Pl, 229 W. Ercoupe Drive- not used, 305 E. Grumman Dr., 9723 NE 3rd Pl, 4101 SE 22nd Street",
        Source: "Zillow Rental Network",
        activity: "10:57PM 01/02/2023"
    },

];

export const guestCards = [
    {
        key: "1",
        name: "Trisha Smith",
        interestedIn: "1221 Mcdonald Dr., 4917 S. Briarwood Dr., 3021 NW 13th Street, 217 NW 121st St., 2324 NW 109th, 721 NW 114th St., 9613 Ridgeview, 425 NW 120th Street, 9723 NE 3rd Pl, 1401 Hampton Dr., 1213 NW 105th Terrace, 3513 Simmons Dr, 732 NE 81st Street, 600 NW 116th Terr., 261 NW 79th Street, 1311 NW 81st St, 248 NW 85th Street, 2633 SW 45th St., 4005 Locust Dr., 12614 Abbotts Way, 4712 Judy Drive, 4024 N Libby Ave, 4904 Gaines St., 5813 SE 10th St., 10917 N. McKinley Avenue, 10721 N. McKinley Ave.",
        lastInquiry: "01/04/2023",
        activity: ["Status Changed To Inactive", "01/04/2023"],
        Source: "Zillow Rental Network",
    },
    {
        key: "2",
        name: "Trisha Smith",
        interestedIn: "1221 Mcdonald Dr., 4917 S. Briarwood Dr., 3021 NW 13th Street, 217 NW 121st St., 2324 NW 109th, 721 NW 114th St., 9613 Ridgeview, 425 NW 120th Street, 9723 NE 3rd Pl, 1401 Hampton Dr., 1213 NW 105th Terrace, 3513 Simmons Dr, 732 NE 81st Street, 600 NW 116th Terr., 261 NW 79th Street, 1311 NW 81st St, 248 NW 85th Street, 2633 SW 45th St., 4005 Locust Dr., 12614 Abbotts Way, 4712 Judy Drive, 4024 N Libby Ave, 4904 Gaines St., 5813 SE 10th St., 10917 N. McKinley Avenue, 10721 N. McKinley Ave.",
        lastInquiry: "01/04/2023",
        activity: ["Status Changed To Inactive", "01/04/2023"],
        Source: "Zillow Rental Network",
    },
    {
        key: "3",
        name: "Trisha Smith",
        interestedIn: "1221 Mcdonald Dr., 4917 S. Briarwood Dr., 3021 NW 13th Street, 217 NW 121st St., 2324 NW 109th, 721 NW 114th St., 9613 Ridgeview, 425 NW 120th Street, 9723 NE 3rd Pl, 1401 Hampton Dr., 1213 NW 105th Terrace, 3513 Simmons Dr, 732 NE 81st Street, 600 NW 116th Terr., 261 NW 79th Street, 1311 NW 81st St, 248 NW 85th Street, 2633 SW 45th St., 4005 Locust Dr., 12614 Abbotts Way, 4712 Judy Drive, 4024 N Libby Ave, 4904 Gaines St., 5813 SE 10th St., 10917 N. McKinley Avenue, 10721 N. McKinley Ave.",
        lastInquiry: "01/04/2023",
        activity: ["Status Changed To Inactive", "01/04/2023"],
        Source: "Zillow Rental Network",
    },
    {
        key: "4",
        name: "Trisha Smith",
        interestedIn: "1221 Mcdonald Dr., 4917 S. Briarwood Dr., 3021 NW 13th Street, 217 NW 121st St., 2324 NW 109th, 721 NW 114th St., 9613 Ridgeview, 425 NW 120th Street, 9723 NE 3rd Pl, 1401 Hampton Dr., 1213 NW 105th Terrace, 3513 Simmons Dr, 732 NE 81st Street, 600 NW 116th Terr., 261 NW 79th Street, 1311 NW 81st St, 248 NW 85th Street, 2633 SW 45th St., 4005 Locust Dr., 12614 Abbotts Way, 4712 Judy Drive, 4024 N Libby Ave, 4904 Gaines St., 5813 SE 10th St., 10917 N. McKinley Avenue, 10721 N. McKinley Ave.",
        lastInquiry: "01/04/2023",
        activity: ["Status Changed To Inactive", "01/04/2023"],
        Source: "Zillow Rental Network",
    },
];

export const coldData = [
    {
        prospect: "Darrien Rich",
        interestedIn: "3117 SW 41st, 3117 SW 41st, 9626 SE 4th",
        Source: "Zillow Rental Network",
        activity: "3:13AM 01/04/2023",
    },
];

export const followUpData = [
   
];